
import { WeaTools } from 'ecCom';

export const getResourcesInfo = (params) => {
    return WeaTools.callApi(`/api/cube/resource/resourceView`, "get", params);
}

export const getCurrentDate = (params) => {
    return WeaTools.callApi(`/api/cube/resource/getCurrentDate`, "get", params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/resource.ts